'use strict';

function ProjectCapacityCalendar(containerID) {
  this.containerID = containerID;
  this.$container = null;

  this.init();
}

ProjectCapacityCalendar.prototype = $.extend({}, {
  constructor: 'ProjectCapacityCalendar',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.containerID + ' .fill-calendar', function () {
      _this.fillCalendar();
      return false;
    });
  },

  fillCalendar: function fillCalendar() {
    var _this = this;

    var capacity = _this.$container.find('.default-capacity').val();

    var filterDay     = [];
    var filterHoliday = _this.$container.find('.project-capacity-calendar-options .holiday').is(':checked');
    var filterErase = _this.$container.find('.project-capacity-calendar-options .erase').is(':checked');

    _this.$container.find('.project-capacity-calendar-options .day:checked').each(function () {
      filterDay.push($(this).val());
    });

    var $tds = $('.project-capacity-calendar .day:not(.empty)');

		if (filterErase) {
			$tds.each(function () {
				$(this).find('input:text').val('');
			});
		}

    $tds.filter(function () {
      var hasDay = false;
      for (var i in filterDay) {
        if ($(this).hasClass(filterDay[i])) {
          hasDay = true;
          break;
        }
      }

      return hasDay;
    }).filter(function () {
      if (!filterHoliday && $(this).hasClass('holiday')) {
        return false;
      }

      return true;
    }).each(function () {
      $(this).find('input:text').val(capacity);
    });
  },

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerID);

    if (_this.$container.length) {
      _this.registerCallbacks();
    }
  }
});
